import { LazyImport, LazyModule } from 'owa-bundling';

export { AttachmentFolderPickerProperties } from './types/AttachmentFolderPickerProperties';
export { AttachmentFolderPickerResult } from './types/AttachmentFolderPickerResult';
export {
    AttachmentSelectedFolderIdentifierType,
    AttachmentSelectedFolderInfo,
} from './types/AttachmentSelectedFolderInfo';
export { DEFAULT_ONE_DRIVE_SPECIAL_ATTACHMENT_FOLDER_PATH } from './constants';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "AttachmentFileProviderFolderPicker"*/ './lazyIndex')
);

export const lazyShowAttachmentFolderPicker = new LazyImport(
    lazyModule,
    m => m.showAttachmentFolderPicker
);

export const lazyInitializeAttachmentFolderPicker = new LazyImport(
    lazyModule,
    m => m.initializeAttachmentFolderPicker
);

export { AttachmentFolderPickerClientProviderType } from './store/schema/AttachmentFolderPickerProviderType';
export { ODProAttachmentFolderPickerResult } from './types/ODProAttachmentFolderPickerResult';
